import { Article } from './Article';
import { Examentraining } from './Examentraining';

export function cartItemIsArticle(item: Article|Examentraining): item is Article {
  return 'id_item' in item;
}

export function cartItemIsTraining(item: Article|Examentraining): item is Examentraining {
  return 'id_training' in item;
}
